import { deviceScheduleData } from "../actionTypes"

// What the Device Schedule page was looking at. Kept in the store so switching
// tabs and coming back does not throw the selection - or a just-sent change -
// away; blacklisted from redux-persist, so a reload still starts clean.
//
// The house itself is not held here: it lives in the multi-house slice, which is
// where loadHouse puts it and where this page reads it from.
const initialState = {
    // The property entry from housesList, not just its code: the picker shows
    // the name and the fetch needs the code.
    property: null,
    // deviceId -> the device document from POST /details, which is what carries
    // the four schedule objects. The store assets payload only names the
    // devices, so without this every row reads as "Not set".
    details: {},
    // deviceId -> sectionKey -> the flat schedule object that was last sent.
    // Merged onto the expected side of a row, so a saved change reads as pending
    // without waiting for a refetch. Cleared on refresh and on property change.
    overrides: {},
    // The dashboard store this page last opened on. The page follows the
    // dashboard's store only when it has changed since, so a property picked
    // here is not undone by every tab switch.
    followedHouseId: null
}

export const deviceScheduleReducer = (state=initialState,action)=>{
    const {type,payload} = action
    switch(type){
        case deviceScheduleData.MERGE:
            return {...state,...payload}
        default :
           return state
    }
}
